"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonSchemaV003 = void 0;
const schema_json_1 = require("../0.0.2/schema_json");
exports.jsonSchemaV003 = Object.assign(Object.assign({}, schema_json_1.jsonSchemaV002), { $id: "http://schema.canotic.com/v0.0.3/", definitions: Object.assign({}, schema_json_1.jsonSchemaV002.definitions) });
